<template>
  <div style="width: 30px; height: 30px;">
    <i class="material-icons btnRecord" v-if="!isRecording" @click="startRecording">mic</i>
    <i class="material-icons btnRedRecord" v-else="v-else" @click="stopRecording">fiber_manual_record</i>
  </div>
</template>
<script>

  import { db, storage } from '../firebase';
  import RecordRTC from 'recordrtc';

  export default {
    //props: [{
    //  options: {
    //    default() {
    //      return {
    //        type: 'audio',
    //        mimeType: 'audio/wav',
    //        bufferSize: 0,
    //        sampleRate: 44100 ,
    //        leftChannel: false,
    //        disableLogs: false,
    //        recordedBlob: null,
    //        audioStream: null
    //      }
    //    }
    //  },
    //}],
    data() {
      return {
        isRecording: false,
        audioRecorder: null,
        blob: null,
      }
    },
    methods: {
      startRecording() {
        var vm = this;
        vm.$parent.isRecording = true;
        var mediaConstraints = { video: false, audio: true };
        navigator.mediaDevices.getUserMedia(mediaConstraints).then(function (audioStream) {
          vm.audioStream = audioStream;
          vm.isRecording = true;
          vm.audioRecorder = RecordRTC(audioStream, { type: 'audio' });
          vm.audioRecorder.startRecording();
        }).catch(function (err) {
          vm.$root.alert.message = vm.$t('audioErrorSSL');
          vm.$root.alert.isShow = true;
        });
      },
      stopRecording() {
        var vm = this;
        vm.audioRecorder.stopRecording(function (singleWebM) {
          vm.isRecording = false;
          vm.blob = vm.audioRecorder.getBlob();
          vm.uploadAudio(vm.blob);
          vm.audioStream.getTracks()[0].stop();
        });
      },
      uploadAudio(blob) {
        var vm = this;
        var filename = vm.$moment().format('YYYYMMDDHHmmss') + '.mp3';
        var file = new File([blob], filename, { type: 'audio/webm' });
        var storageRef = storage.ref('Records/' + file.name);
        var task = storageRef.put(file);
        task.on('state_changed',
          function progress(snap) {
            //vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100;
          },
          function error(err) {
            vm.$parent.audioObj = "ERROR";
          },
          function complete() {
            //vm.$parent.audioUrl = task.snapshot.downloadURL;
            vm.$parent.audioObj = { Type: "Record", FileName: file.name, FileUrl: task.snapshot.downloadURL };
          }
        );
      },
    },
    destroyed() {
      try {
        this.$Log("destroyed recorder ....")
        this.stopRecording();
      }
      catch (e) {
      }
    }
  }

</script>

<style>
  .btnRecord {
    color: #9B9B9B;
    cursor: pointer;
    padding-top: 5px;
  }

    .btnRecord:hover {
      color: #01579B;
    }

  .btnRedRecord {
    color: #CC2636;
    cursor: pointer;
    padding-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// Recorder.vue?b1614178